export default __webpack_public_path__ + "static/media/salesReportIcon.8357be30.svg";